<div *ngIf="isShowDetail" class="detail-wrap" [ngStyle]="{'width':isFeedLoaded?'660px':'330px'}"
	 #details>
	<div *ngIf="showOperation" class="detail-operation" role="button" aria-label="show on map">
		<mat-icon (click)="showOnMap($event)" matTooltip="show on map">room</mat-icon>
	</div>
	<div class="detail-close" [class.hidden]="(placeFeeds&&placeFeeds.length)&&!isFeedLoaded"
		 [class.feed-close]="isFeedLoaded" (click)="closeFeeds()" role="button" aria-label="close">
		<mat-icon>close</mat-icon>
	</div>

	<ig-row>
		<ig-col *ngIf="!isShowFeedForMobile" class="detail-section"
				[xs]="12" style="transition: 0ms">
			<div class="detail-info">
				<ig-image #itemImage class="detail-image" [imageUrl]="item.cover?.source"></ig-image>

				<ig-row class="detail-info-wrap">
					<ig-col [xs]="12" class="detail-title ellipsis">{{item.name}}</ig-col>
				</ig-row>

				<div *ngIf="type==='event'" class="detail-button-wrap">
					<ig-add-to-trip-menu *ngIf="isShowAddtoMyTrip" [class.full-width]="type==='event'" [class.half-width]="type==='place'" [hubName]="hubName" [item]="item"></ig-add-to-trip-menu>
					<div add *ngIf="item['isOnlineEvent']">OnLine Event</div>

					<p class="event-host">Event created by
						<span>
							<a [href]="item.hostLink" target="_blank">{{item?.owner?.name}}</a>
						</span>
					</p>

					<ig-row class="event-time-wrap">
						<ig-col [xs]="1">
							<mat-icon>date_range</mat-icon>
						</ig-col>
						<ig-col [xs]="11">
							<div class="event-time" *ngIf="!item.eventTimes||!item.eventTimes.length">
								<span *ngIf="item.startTimeFormatted">{{item.startTimeFormatted}}{{item.endTimeFormatted ? ' - ' + item.endTimeFormatted : ''}}</span>
							</div>
							<div *ngIf="item.eventTimes && item.eventTimes.length">
								<div class="event-time"
									 *ngFor="let timeRange of trancatedEventTimes">
									{{timeRange.startTimeFormatted}}{{timeRange.endTimeFormatted ? ' - ' + timeRange.endTimeFormatted : ''}}
								</div>

								<div *ngIf="item.eventTimes.length>3" class="times-more" (click)="showMoreTimes();">
									{{trancatedEventTimes.length === 3 ? 'Show More' : 'Show Less'}}
								</div>
							</div>
						</ig-col>
					</ig-row>

					<ig-row *ngIf="item.ticketUri" class="event-item-wrap">
						<ig-col [xs]="1">
							<mat-icon>receipt</mat-icon>
						</ig-col>
						<ig-col [xs]="11">
							<div class="event-time">
								<a href="{{item.ticketUri}}" target="_blank">{{item.ticketUri}}</a>
							</div>
						</ig-col>
					</ig-row>

					<ig-row *ngIf="item.address" class="event-item-wrap">
						<ig-col [xs]="1">
							<mat-icon>room</mat-icon>
						</ig-col>
						<ig-col [xs]="11">
							<div class="event-time">
								{{item.address.address || item.address}}
							</div>
						</ig-col>
					</ig-row>
				</div>

				<div *ngIf="type==='place'" class="detail-button-wrap">
					<div class="flex">
						<ig-button (trigger)="showNearByPlaces()" class="nearby-places-btn half-width">
							<mat-icon>room</mat-icon>
							Nearby Places
						</ig-button>
						<ig-button (trigger)="isShowNearbyPlaces=false" class="google-btn half-width">
							<span logo>G</span>
							Google Reviews
						</ig-button>
					</div>
					<ig-add-to-trip-menu *ngIf="isShowAddtoMyTrip" [hubName]="hubName" [item]="item"></ig-add-to-trip-menu>

					<p *ngIf="item.hostLink" class="event-host">Listed via
						<a target="_blank" [href]="item.hostLink">{{item.socialName === 'google' ? 'Google' : 'Unknown'}}</a>
					</p>

					<ig-row class="event-item-wrap">
						<ig-col [xs]="1">
							<mat-icon>list</mat-icon>
						</ig-col>
						<ig-col [xs]="11">
							<div class="event-time">
								{{item.category}}
							</div>
						</ig-col>
					</ig-row>

					<ig-row *ngIf="item.address" class="event-item-wrap">
						<ig-col [xs]="1">
							<mat-icon>room</mat-icon>
						</ig-col>
						<ig-col [xs]="11">
							<div class="event-time">
								{{item.address.address || item.address}}
							</div>
						</ig-col>
					</ig-row>

					<ig-row class="event-item-wrap" *ngIf="item?.website">
						<ig-col [xs]="1">
							<mat-icon>web</mat-icon>
						</ig-col>
						<ig-col [xs]="11">
							<a href="{{item?.website}}" target="_blank" style="word-break: break-all">{{item?.website}}</a>
						</ig-col>
					</ig-row>

					<ig-row class="event-item-wrap" *ngIf="item?.phone">
						<ig-col [xs]="1">
							<mat-icon>phone</mat-icon>
						</ig-col>
						<ig-col [xs]="11">
							<span>{{item?.phone}}</span>
						</ig-col>
					</ig-row>

					<ig-row class="event-item-wrap" *ngIf="item?.emails">
						<ig-col [xs]="1">
							<mat-icon>email</mat-icon>
						</ig-col>
						<ig-col [xs]="11">
							<span>{{item?.emails}}</span>
						</ig-col>
					</ig-row>

					<ig-row class="event-item-wrap" *ngIf="item?.priceRange">
						<ig-col [xs]="1">
							<mat-icon>attach_money</mat-icon>
						</ig-col>
						<ig-col [xs]="11">
							<span>{{item?.priceRange}}</span>
						</ig-col>
					</ig-row>

					<ig-row class="event-item-wrap" *ngIf="item.checkins||item.rating">
						<ig-col [xs]="1">
							<mat-icon>star</mat-icon>
						</ig-col>
						<ig-col [xs]="11">
							<span *ngIf="item.checkins">{{item?.checkins}} Checkins</span>
							<span *ngIf="item.rating">{{item?.rating}}</span>
						</ig-col>
					</ig-row>
				</div>

				<div *ngIf="item.about||item.description" class="detail-description">
					{{item.about}}<br *ngIf="item.about" /><br *ngIf="item.about" />
					<div #description></div>
				</div>

			</div>
			<div class="detail-share">
				<ig-social-share [item]="item"></ig-social-share>
			</div>
		</ig-col>
		<ig-col [md]="6" [xs]="12" class="feed-col"
				*ngIf="(item.socialName==='facebook'&&isFeedLoaded)||(item.socialName==='google'&&featuresToggle.googleReviews&&isFeedLoaded)">
			<div class="feed-wrap ">
				<div class="fb-post-title" *ngIf="placeFeeds&&placeFeeds.length">
					<img [src]="facebookLogo" alt="">
					FACEBOOK POSTS
				</div>
				<div class="facebook-posts" *ngIf="(item.socialName==='facebook'&&isFacebookLoggedIn)||(item.socialName==='google')">
					<ng-container *ngIf="(item.socialName==='google'&&featuresToggle.facebookPosts)||(item.socialName==='facebook'&&isFacebookLoggedIn)">
						<ig-facebook-post *ngFor="let post of placeFeeds"
										  [post]="post">
						</ig-facebook-post>
						<ig-button *ngIf="placeFeedPaging"
								   [isAsync]="true"
								   size="md"
								   (trigger)="getNextFacebookPlaceFeed($event)">
							Load More
						</ig-button>
					</ng-container>

					<div *ngIf="googleInfo&&featuresToggle.googleReviews&&canShowGoogleReviews" class="google-review-wrap" [class.no-fb-post-google-review-wrap]="!placeFeeds||!placeFeeds.length">
						<ig-google-place-reviews *ngIf="!isShowNearbyPlaces" [reviews]="googleInfo?.reviews||googleInfo?.googleReviews"
												 [placeId]="item?.id"
												 [googleLink]="googleInfo?.url||googleInfo?.hostLink"></ig-google-place-reviews>
						<ig-nearby-places *ngIf="isShowNearbyPlaces" [position]="'right'" [currentPlace]="item" [source]="placeSource"
										  (onGotoPlace)="gotoPlace($event)"
						></ig-nearby-places>
					</div>
				</div>
			</div>
		</ig-col>
	</ig-row>


</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/trip/trip.float.detail/trip.float.detail.component.html